export const APP_DATA = {
  apiUrl: 'https://apicitrusplanner.clasol.com/api/',
  empresaNombre: 'Citrus Planner - Clasol',
}
